var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsCog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 18C17.1046 18 18 17.1046 18 16C18 14.8954 17.1046 14 16 14C14.8954 14 14 14.8954 14 16C14 17.1046 14.8954 18 16 18Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 13.711L21.3841 15.314V16.686L23 18.289L21.5507 20.711L19.3043 20.165L18.0797 20.851L17.4493 23H14.5507L13.9203 20.851C13.308 20.508 13.3088 20.5133 13.3088 20.5133C13.3088 20.5133 13.2851 20.5014 12.6957 20.165L10.4493 20.711L9 18.289L10.6159 16.686V15.314L9 13.711L10.4493 11.289L12.6957 11.835L13.9203 11.149L14.5507 9H17.4493L18.0797 11.149L19.3043 11.835L21.5507 11.289L23 13.711ZM21.7398 18.4475L21.0709 19.5653L19.1586 19.1005L17.235 20.178L16.7005 22H15.2995L14.765 20.178L14.409 19.9786C14.1029 19.8071 13.946 19.72 13.8647 19.6755C13.8276 19.6553 13.7949 19.6376 13.7686 19.6243L13.7512 19.6156L13.7262 19.6015C13.6512 19.5589 13.5008 19.4731 13.1979 19.3002L12.8459 19.0994L10.9291 19.5653L10.2602 18.4475L11.6159 17.1026V14.8974L10.2602 13.5525L10.9291 12.4347L12.8414 12.8995L14.765 11.822L15.2995 10H16.7005L17.235 11.822L19.1586 12.8995L21.0709 12.4347L21.7398 13.5525L20.3841 14.8974V17.1026L21.7398 18.4475ZM14.2979 20.3665C14.2973 20.3626 14.2987 20.3708 14.3006 20.3858L14.2986 20.3713L14.2979 20.3665Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsCog);
export default __webpack_public_path__ + "static/media/settings_cog.4a882a8992ac450da0461d62d3745e82.svg";
export { ForwardRef as ReactComponent };